<template>
  <div class="flex items-center gap-3 py-2">
    <p class="title">{{ label }}</p>
    <vs-select autocomplete v-model="selectData.selectType" class="flex-1" @change="changeSelectType">
      <vs-select-item v-for="option in options" :key="option.label" :text="option.label" :value="option.label" />
    </vs-select>

    <!-- 포함/제외 -->
    <vs-select autocomplete v-model="selectData.selectLogical" class="flex-1">
      <vs-select-item text="포함" value="포함" />
      <vs-select-item text="제외" value="제외" />
    </vs-select>

    <!-- CUSTOM -->
    <ml-input v-if="selectOptionData.type === 'input'" v-model="selectData.customInput" style="width: 320px" :placeholder="`${selectOptionData.label} 입력`"/>
    <vs-select v-else-if="selectOptionData.type === 'selector'" autocomplete v-model="selectData.customInput" style="width: 320px;" :placeholder="`{${selectOptionData.label} 선택}`">
      <vs-select-item v-for="subOption in selectOptionData.sub" :key="`suboption_${subOption.label}`" :text="subOption.label" :value="subOption.value || subOption.label " />
    </vs-select>
    <DateSelectorRang v-else-if="selectOptionData.type === 'dateRang'" v-model="selectData.customInput" class="flex items-center gap-2" style="width: 320px" />

    <button class="trash-button" @click="$emit('delete')"><feather-icon icon="Trash2Icon" style="width: 20px; height: 20px; color: #7e72f2" class="align-bottom" /></button>
  </div>
</template>

<script>
import DateSelectorRang from "@/components/selector/DateSelectorRang";
export default {
  components: { DateSelectorRang },
  props: {
    isReadonly: Boolean,
    label: { type: String, default: "필터" },
    options: {
      type: Array,
      default: () => [],
    },
    value: Object,
  },
  data() {
    return {
      selectData: this.value,
    };
  },
  computed: {
    selectOptionData() {
      return this.options.find((option) => option.label === this.selectData.selectType);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.selectData = value;
      },
    },
    selectData: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    changeSelectType() {
      this.selectData.customInput = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 48px;
  font-size: 14px;
  font-weight: 500;
}

.select-buttons {
  flex: 1;
  & > button {
    width: 50%;
    height: 38px;

    font-size: 14px;
    font-weight: 400;

    background: white;
    border: solid 1px #cdcdcd;
    cursor: pointer;

    &:first-child {
      border-right: none;
      border-radius: 5px 0px 0px 5px;
      &.action {
        color: #fff;
        background: #28c76f;
      }
    }
    &:last-child {
      border-radius: 0px 5px 5px 0px;
      &.action {
        color: #fff;
        background: #ea5455;
      }
    }
  }
}

.trash-button {
  width: 36px;
  height: 38px;
  background: none;
  border: none;
  cursor: pointer;
}
</style>
